






















































































































































































































































































































import {
  getChecklists,
  createChecklist,
  deleteChecklist,
  checklistPostReq,
  genPostReq,
} from "@/services/checklist.service";

import Vue from "vue";
import TransferInspectModal from "@/components/TransferInspectModal.vue";
import ImportChecklistModal from "@/components/ImportChecklistModal.vue";
import SettingsChecklist from "@/components/SettingsChecklist.vue";
import ImportCSVTable from "@/components/ImportCSVTable.vue";
import UploadFileChecklist from "@/components/UploadFileChecklist.vue";
import HistoryChecklist from "@/components/HistoryChecklist.vue";

export default {
  data() {
    return {
      na1: false,
      showCsvImport: false,
      //the_checklists: [],
      initLoaded: false,
      showUploadFile: false,
      create_dialog: false,
      create_progress: false,
      create_entry: { nane: "", name_en: "", select_machine_group: "public" },
      create_error: false,
      delete_dialog: false,
      restore_dialog: false,
      backup_restore_stamp: null,
      delete_item: {},
      delete_progress: false,
      export_dialog: false,
      showTransferInspect: false,
      coldata: null,
      backup_restore_item: null,
      rowdata: null,
      showImportInspect: false,
      showSettingsInspect: false,
      cl_item: null,
      items_machine_groups: ["public", "internal"],
      snackbar: false,
      snackbar_text: "",
      snackbar_bottom: false,
      snackbar_bottom_text: "",
      showHistoryInspect: false, 
      modal_title: "Checkliste exportieren",
      dialog1: false,
      currentSelectedChecklistItem: null,
    };
  },
  components: {
    TransferInspectModal,
    ImportChecklistModal,
    SettingsChecklist,
    ImportCSVTable,
    UploadFileChecklist,
    HistoryChecklist,
  },

  mounted() {
    this.$store.state.headerTitle = this.$t("NAVI.CHECKLISTS");



    getChecklists(this.$store.state.lang)
      .then((resp) => {
        if (resp.status == "success") {
          console.log(resp.data.list);
          this.$store.state.checklists = resp.data.list;
          //this.the_checklists = resp.data.list
          this.initLoaded = true;
        }
      })
      .catch((e) => {
        this.$store.dispatch("api_error", e);
      });
  },
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
    userRole: function () {
      if (this.$store.getters.userRole) {
        return this.$store.getters.userRole;
      }
      return {};
    },
    checklists() {
      return this.$store.state.checklists;
    },
  },
  methods: {
    dialogClosedUpload(info) {
      this.showUploadFile = false;

      if (info) {
        console.log("info", info);

        this.currentSelectedChecklistItem.filename = info;

        this.dialog1 = true;
        checklistPostReq(
          "inout-import",
          this.currentSelectedChecklistItem
        ).then((resp) => {
          this.dialog1 = false;
          this.dialogOpenCsvImport(
            resp.item.col,
            resp.item.row,
            this.currentSelectedChecklistItem
          );
        });
      }
    },
    dialogClosedCsvImport(info) {
      this.showCsvImport = false;

      if (info == "imported") {
        this.snackbar_bottom = true;
        this.snackbar_bottom_text = "The checklist was imported successfully.";
      }
    },
    openUploadFile() {
      this.showUploadFile = true;
    },
    dialogOpenCsvImport(col, row, item) {
      this.rowdata = row;
      this.coldata = col;
      this.item = item;
      this.showCsvImport = true;
    },
    openChecklist(item) {
      this.$router.push({ name: "checklist", params: { uid: item.uid } });
    },
    openRotorblades(item) {
      this.$router.push({ name: "rotorblades", params: { uid: item.uid } });
    },
    openCheckIdOptions(item) {
      this.$router.push({
        name: "check_id_options",
        params: { uid: item.uid },
      });
    },
    updateChecklist(item) {
      this.create_entry = {
        name: item.name,
        name_en: item.name_en,
        uid: item.uid,
      };
      this.create_dialog = true;
    },
    inoutExport(item) {
      this.dialog1 = true;
      checklistPostReq("inout-export", item).then((resp) => {
        this.dialog1 = false;
        console.log(resp);

        this.snackbar_bottom = true;
        this.snackbar_bottom_text = "The checklist was exported successfully.";

        var tempLink = document.createElement("a");
        tempLink.href =
          Vue.prototype.$apiBase + "/fileDownload?file=" + resp.item.filename;
        tempLink.setAttribute("download", "checkliste.csv");
        tempLink.click();
      });
    },
    restoreChecklistAction() {
      this.restore_dialog = false;
      if (this.backup_restore_item) {
        this.dialog1 = true;

        checklistPostReq("restore-action", this.backup_restore_item).then(
          (resp) => {
            this.dialog1 = false;
            if (resp.item.restore_item.components > 0) {
              this.snackbar_bottom = true;
              this.snackbar_bottom_text =
                "The checklist was restored from the backup. ";
            } else {
              this.snackbar_bottom = true;
              this.snackbar_bottom_text = "There is no backup available.";
            }
          }
        );
      }
    },
    restoreChecklist(item) {
      this.dialog1 = true;

      checklistPostReq("latest-backup", item).then((resp) => {
        this.dialog1 = false;

        if (resp.item && resp.item.backup_entry) {
          this.backup_restore_item = item;
          this.backup_restore_stamp = resp.item.backup_entry.created_at;
          this.restore_dialog = true;
        } else {
          this.snackbar_bottom = true;
          this.snackbar_bottom_text = "There is no backup available.";
        }
      });
    },
    backupChecklist(item) {
      this.dialog1 = true;
      checklistPostReq("backup-action", item).then((resp) => {
        this.dialog1 = false;
        this.snackbar_bottom = true;
        this.snackbar_bottom_text = "The backup has been created.";
      });
    },

    inoutImport(item) {
      this.currentSelectedChecklistItem = item;

      this.openUploadFile();
      /*
      this.dialog1 = true
      checklistPostReq('inout-import', item)
       .then(resp => {
         this.dialog1 = false
         this.dialogOpenCsvImport(resp.item.col, resp.item.row, item)
       })
       */
    },
    csvExport(item) {
      this.modal_title = "CSV Export...";
      this.export_dialog = true;
      checklistPostReq("export-csv", item).then((resp) => {
        //console.log(resp)
        this.export_dialog = false;

        var csvData = new Blob(["\uFEFF" + resp.item.csv], {
          type: "text/csv;charset=windows-1252",
        });
        var csvURL = null;
        if (navigator.msSaveBlob) {
          csvURL = navigator.msSaveBlob(csvData, "download.csv");
        } else {
          csvURL = window.URL.createObjectURL(csvData);
        }
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute(
          "download",
          new Date().getFullYear() +
            "_" +
            (new Date().getMonth() + 1) +
            "_" +
            new Date().getDate() +
            "_checkliste.csv"
        );
        tempLink.click();

        /*
          if (resp.status == "success") {
            window.open(`${this.$apiBase}/importjson/download-csv/${resp.item.cl_uid}/${resp.item.file_uid}`)
          }
       */
      });

      //   checklistPostReq('export-json', item)
    },
    exportChecklist(item, compress) {
      item.compress = compress;
      this.modal_title = "Checkliste exportieren...";
      this.export_dialog = true;
      checklistPostReq("export-json", item)
        .then((resp) => {
          this.export_dialog = false;
          if (resp.status == "success") {
            window.open(
              `${this.$apiBase}/importjson/download-json/${resp.item.cl_uid}/${resp.item.file_uid}`
            );
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    showHistory(item) {
      this.cl_item = item;
      this.showHistoryInspect = true;
    },
    showSettings(item) {
      this.cl_item = item;
      this.showSettingsInspect = true;
    },
    duplicateChecklist(item) {
      this.export_dialog = true;
      this.modal_title = "Checkliste duplizieren...";
      checklistPostReq("duplicate", item)
        .then((resp) => {
          this.export_dialog = false;
          if (resp.status == "success") {
            this.$store.state.checklists = resp.item.list;
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    newChecklist() {
      this.create_entry = { nane: "", name_en: "" };
      this.create_dialog = true;
    },
    csvImport(item) {
      this.$router.push({
        name: "checklist_import",
        params: { uid: item.uid },
      });
    },
    importChecklist() {
      this.showImportInspect = true;
    },
    deleteChecklist(item) {
      this.delete_dialog = true;
      this.delete_item = item;
    },
    transferChecklist(item) {
      this.cl_item = item;
      this.showTransferInspect = true;
    },
    dialogTransferClosed: function (val) {
      this.showTransferInspect = false;
    },
    dialogImportClosed: function (val) {
      this.showImportInspect = false;

      if (val.saved) {
        this.snackbar = true;
        this.snackbar_text =
          "Abhängig vom Umfang der Checkliste kann es Minuten dauern, bis alle Komponenten und Aufgaben der Checkliste importiert sind.";
      }
    },
    dialogHistoryClosed() {
      this.showHistoryInspect = false;
    },
    dialogSettingsClosed() {
      this.showSettingsInspect = false;
    },
    deleteChecklistAction() {
      this.delete_progress = true;
      deleteChecklist(this.delete_item)
        .then((resp) => {
          if (resp.status == "success") {
            this.delete_dialog = false;
            this.delete_progress = false;
            this.$store.state.checklists = resp.list;
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
    saveNewChecklist() {
      this.create_error =
        !this.create_entry.name || this.create_entry.name.length <= 1;

      if (this.create_entry.name && this.create_entry.name.length > 1) {
        this.create_progress = true;

        if (!this.create_entry.select_machine_group) {
          this.create_entry.select_machine_group = "public";
        }

        createChecklist(this.create_entry)
          .then((resp) => {
            if (resp.status == "success") {
              this.create_dialog = false;
              this.create_progress = false;

              if (resp.uid) {
                this.$router.push({
                  name: "checklist",
                  params: { uid: resp.uid },
                });
              }
              if (resp.list) {
                this.$store.state.checklists = resp.list;
              }
            }
          })
          .catch((e) => {
            this.$store.dispatch("api_error", e);
          });
      }
    },
  },
};
